/**
 * Lazy bridge to ErrorReportingService — avoids circular imports.
 *
 * ErrorReportingService registers itself here on init.
 * Consumers call getErrorReportingService() instead of require().
 */
let _instance = null;

export function registerErrorReportingService(service) {
  _instance = service;
}

export function getErrorReportingService() {
  return _instance;
}
